
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/annual-conference/dashboard",
      function () {
        return require("private-next-pages/events/annual-conference/dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/annual-conference/dashboard"])
      });
    }
  